export default class Menu {
  /**
   * An array of HTMLElements of all the triggers of the menu
   *
   * @memberof Menu
   */
  triggers = [];

  /**
   * The HTMLElement of the menu
   *
   * @memberof Menu
   */
  menu;

  /**
   * An array of HTMLElements of all the submenus of the menu
   *
   * @memberof Menu
   */
  dropdownMenus;

  /**
   * The state of the menu
   *
   * @memberof Menu
   */
  isOpen = false;



  /**
   *Creates an instance of Menu.
   * @param {string} menuSelector
   * @param {string} triggerSelector
   * @param {boolean} [bodyClasses=false]
   * @param {number} breakpoint
   * @memberof Menu
   */
  constructor(menuSelector, triggerSelector, bodyClasses = false) {
    this.menu = document.querySelector(menuSelector);
    if (!this.menu) {
      console.error('No menu found.');
      return;
    }
    this.triggers = Array.from(document.querySelectorAll(triggerSelector));
    if (!this.triggers.length) {
      console.error('No trigger found.');
      return;
    }
    this.bodyClasses = bodyClasses;

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleMenu();
      });
    });

    document.body.addEventListener('click', (event) => {
      if (
        !event.target.closest(menuSelector) &&
        !event.target.classList.contains(menuSelector) &&
        this.isOpen
      ) {
        this.closeMenu();
      }
    });

    this.dropdownMenus = Array.from(
      document.querySelectorAll('.menu-item-has-children')
    );
    this.dropdownMenus.forEach((menuItem) => {
      if (menuItem.classList.contains('current-menu-parent') || menuItem.classList.contains('current-menu-item')) {
        this.toggleSubMenu(menuItem);
      }
      menuItem.firstElementChild.addEventListener('click', () => {
        // e.preventDefault();
        this.toggleSubMenu(menuItem);
      });
    });

    window.addEventListener('resize', () => {
      this.recalculateSubMenuHeight();
    });
  }

  /**
   * Toggle menus state
   *
   * @memberof Menu
   */
  toggleMenu() {
    if (this.isOpen) {
      this.isOpen = false;
      if (this.bodyClasses) {
        document.body.classList.remove(...this.bodyClasses);
      }
      this.menu.classList.remove('open');
      this.closeAllSubMenu(false);
      this.triggers.forEach((trigger) => trigger.classList.remove('active'));
      let event = new Event('sw.menu.close');
      this.menu.dispatchEvent(event);
    } else {
      this.isOpen = true;
      if (this.bodyClasses) {
        document.body.classList.add(...this.bodyClasses);
      }
      this.menu.classList.add('open');
      this.triggers.forEach((trigger) => trigger.classList.add('active'));
      let event = new Event('sw.menu.open');
      this.menu.dispatchEvent(event);
    }
  }

  /**
   * Opens Menu
   *
   * @memberof Menu
   */
  openMenu() {
    if (!this.isOpen) {
      this.isOpen = true;
      if (this.bodyClasses) {
        document.body.classList.add(...this.bodyClasses);
      }
      this.menu.classList.add('open');
      this.triggers.forEach((trigger) => trigger.classList.add('active'));
      let event = new Event('sw.menu.open');
      this.menu.dispatchEvent(event);
    }
  }

  /**
   * Closes menu
   *
   * @memberof Menu
   */
  closeMenu() {
    if (this.isOpen) {
      this.isOpen = false;
      if (this.bodyClasses) {
        document.body.classList.remove(...this.bodyClasses);
      }
      this.menu.classList.remove('open');
      this.triggers.forEach((trigger) => trigger.classList.remove('active'));
      let event = new Event('sw.menu.close');
      this.menu.dispatchEvent(event);
    }
  }

  /**
   * Calculates the submenu height
   *
   * @returns
   * @memberof Menu
   */
  recalculateSubMenuHeight() {
    const submenu = this.menu.querySelector(
      '.menu-item-has-children.open .sub-menu'
    );
    let submenuHeight = 0;
    if (submenu) {
      const submenuItems = submenu.querySelectorAll('.menu-item');
      submenuItems.forEach((menuItem) => {
        submenuHeight += menuItem.clientHeight;
      });
      submenu.style.height = submenuHeight + 'px';
    }

    return submenuHeight;
  }

  /**
   * Toggle a submenu state
   *
   * @param {HTMLElement} menuItem
   * @memberof Menu
   */
  toggleSubMenu(menuItem) {
    const subMenu = menuItem.querySelector('.sub-menu');
    let openMenuItem, openSubMenu;
    if (subMenu) {
      openMenuItem = this.menu.querySelector('.menu-item-has-children.open');
      if (menuItem.classList.contains('open')) {
        menuItem.classList.remove('open');
        subMenu.style.height = '';
      } else {
        menuItem.classList.add('open');
        if (openMenuItem) {
          openSubMenu = openMenuItem.querySelector('.sub-menu');
          openMenuItem.classList.remove('open');
          openSubMenu.style.height = '';
        }
        this.recalculateSubMenuHeight();
      }
    }
  }

  /**
   * Closes a submenu
   *
   * @param {HTMLElement} item
   * @returns
   * @memberof Menu
   */
  closeSubMenu(item) {
    const submenu = item.querySelector('.sub-menu');
    if (item.classList.contains('open')) {
      item.classList.remove('open');
      submenu.style.height = '';
      return;
    }
  }

  /**
   * Closes all submenus
   *
   * @memberof Menu
   */
  closeAllSubMenu() {
    this.dropdownMenus.forEach((menuItem) => this.closeSubMenu(menuItem));
  }
}
